// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"4889da25","172":"e12e1668","197":"91e08f3f","381":"4889da25","617":"5f77bcdd","619":"52cab41c","639":"bccc64aa"}[chunkId] + ".chunk.css";
};